import { APIGet, APIPost } from '../services/API'
import { getCookie } from '../services/Utils'


/*
args {
    page: int
}
*/
export const getAnnouncements = (args) => (dispatch, getState) => {

    // Get Site
    const { site } = getState().Settings;

    // Dispatch Result
    dispatch({
        type: 'GETTING_ANNOUNCEMENTS',
        payload: {
            ui: "loading"
        }
    });

    let url = site+'/api/v1/announcements';

    let qs = [];

    if(args.pid) qs.push('pid='+args.pid);
    let queryString = qs.join('&');
    

    url += '?'+queryString;

    // Send Request To Get Events
    APIGet(url)
    .then(res => res.json())
    .then(json => {

        // Filter Items that have been seen via cookie `'announcement_seen_'+item.ID`
        const items = json.filter(item => {

            const hasCookie = getCookie('announcement_seen_'+item.ID)
            if(!hasCookie) return item;
            
        })
        

        // Format:
        let formatted = {};
        formatted.notifications = [];
        formatted.topbanners = [];
        items.map(item => {
            if(item.style === 'notification') formatted.notifications.push(item);
            else if(item.style === 'topbanner') formatted.topbanners.push(item);
            else formatted.notifications.push(item);
        })

        dispatch({ type: 'GET_ANNOUNCEMENTS_SUCCESS',payload: {ui:"success",items:formatted}});
    })
    .catch(e => {
        dispatch({ type: 'GET_ANNOUNCEMENTS_ERROR',payload: {ui:"error",message:e}});
    })

}